// ---------------------------------------------------------------------------
// G.19: Breakout Rooms — Shared Types and Constants
// ---------------------------------------------------------------------------

export type AssignmentMode = "random" | "manual" | "self_select";
export type BreakoutStatus = "draft" | "active" | "ended";
export type ActivityLevel = "low" | "medium" | "high";

export interface RoomDefinition {
  name: string;
  topic: string;
  maxParticipants: number | null;
}

export interface BreakoutRoom {
  id: string;
  name: string;
  topic: string | null;
  livekitRoom: string | null;
  participantCount: number;
  activityLevel: ActivityLevel;
}

export interface BreakoutStatusData {
  id: string;
  status: BreakoutStatus;
  assignmentMode: AssignmentMode;
  timerMinutes: number;
  warningMinutesBefore: number;
  startedAt: string | null;
  endsAt: string | null;
  endedAt: string | null;
  timeRemainingSeconds: number | null;
  rooms: BreakoutRoom[];
  broadcasts: Array<{ message: string; sentAt: string }>;
}

export interface BreakoutStatusResponse {
  data: BreakoutStatusData;
}

export interface CreateBreakoutResponse {
  breakoutId: string;
  rooms: Array<{ id: string; name: string; topic: string | null; livekitRoom: string }>;
}

// Constants
export const MAX_ROOMS = 8;
export const MIN_ROOMS = 2;
export const DEFAULT_TIMER_MINUTES = 10;
export const DEFAULT_WARNING_MINUTES = 2;
export const POLL_INTERVAL_MS = 3000;

export const ACTIVITY_COLORS: Record<ActivityLevel, string> = {
  low: "bg-[var(--color-muted-foreground)]/30",
  medium: "bg-yellow-400",
  high: "bg-green-500",
};

export const ACTIVITY_LABELS: Record<ActivityLevel, string> = {
  low: "Quiet",
  medium: "Active",
  high: "Lively",
};

export function formatTime(seconds: number): string {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, "0")}`;
}
